import { BuzolaProvider, Outlet } from '@buzola/router'
import { pageRegistry, routes } from './buzola.gen'
import { UchoWidget } from './components/ucho'

// Providers/layout live in routes/_layout.tsx so the login subtree and the
// authenticated app can use different ContemberClient scopes (NPI pattern).
export const Application = () => (
	<BuzolaProvider pageRegistry={pageRegistry} routes={routes}>
		<Outlet />
		<UchoWidget />
	</BuzolaProvider>
)
